import React from 'react';
import ReactDOM from 'react-dom/client';
import '@gravity-ui/uikit/styles/styles.css';
import '@gravity-ui/uikit/styles/fonts.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {loadRuntimeConfig} from './shared/config/runtime-config';
import {updateApiBaseUrls} from './shared/api/api.service';
import {updatePublicApiBaseUrl} from './shared/api/publicApi';

async function bootstrap() {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

  try {
    await loadRuntimeConfig();
    updateApiBaseUrls();
    updatePublicApiBaseUrl();
  } catch (error) {
    console.error('Failed to load runtime config:', error);
  }

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
  reportWebVitals();
}

bootstrap();
